import { Box, Heading, Stack, Text } from '@chakra-ui/react'
import omit from 'lodash-es/omit'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { getReferUrl } from '@/client/services/url'

import PublicImage from '@/components/PublicImage/PublicImage'
import ShwLink, { type ShwLinkTrackClickProps } from '@/components/ShwLink'
import ModalV3 from '@/components/UI/Modal/ModalV3'

const SUMMER_CAMP_CONFIRMATION_PARAM = 'summer_camp_confirmation'

function getLinkTrackEventProps(type: string): ShwLinkTrackClickProps {
  return {
    action: 'Click Summer Camp Confirmation Modal',
    extra: {
      type,
    },
  }
}

export default function SummerCampConfirmationModal({
  type,
}: {
  type: 'session' | 'series'
}): JSX.Element | null {
  const router = useRouter()
  const showSummerCampConfirmation = router.query[SUMMER_CAMP_CONFIRMATION_PARAM] != null

  const hideModalCallback = useCallback(async () => {
    await router.replace(
      { query: omit(router.query, [SUMMER_CAMP_CONFIRMATION_PARAM]) },
      undefined,
      { scroll: false }
    )
  }, [router])

  return (
    <ModalV3
      open={showSummerCampConfirmation}
      onClose={hideModalCallback}
      size="xl"
      body={() => (
        <Stack direction="column" spacing={4} align="center">
          <PublicImage src="/summer-camp-2022/logo.svg" maxWidth="200px" />
          <Box textAlign="center" my={4}>
            <Heading size="xl" as="h4">
              Invite a friend to join this {type} with you!
            </Heading>
          </Box>
          <Text>
            If you use your{' '}
            <ShwLink trackEvent={getLinkTrackEventProps('Referral Page')} href={getReferUrl()}>
              referral code
            </ShwLink>{' '}
            to refer to Schoolhouse, and they attend a Summer Camp session, you&apos;ll be entered
            in a raffle to win one of 20 Schoolhouse{' '}
            <ShwLink
              href="https://cdn.shopify.com/s/files/1/0565/3705/5441/products/d21fbcc544efd32ae6fb6b20a3208582_940x.jpg"
              trackEvent={getLinkTrackEventProps('Water Bottle')}
            >
              CamelBak water bottles
            </ShwLink>
            . ✨
          </Text>
          <Text>
            If you&apos;d like to post about Summer Camp on social media, here are some{' '}
            <ShwLink
              trackEvent={getLinkTrackEventProps('Social Media Graphics')}
              href="https://drive.google.com/drive/folders/11jtcbBPGKthBQEvppKYIIcis_Djq4r-V"
            >
              graphics
            </ShwLink>{' '}
            you can use.
          </Text>
        </Stack>
      )}
    />
  )
}
